import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-content">
            <div className="footer-about">
              <h3>Tea Gardens GP</h3>
              <p>Located in the heart of Tea Gardens, our practice proudly serves the local community and surrounding regions, including Hawks Nest and the Mid-Coast area. Our caring and experienced doctors provide a full range of GP medical services with a focus on your health, comfort, and well-being.</p>
              <div className="social-links">
                <a href="https://www.facebook.com/profile.php?id=61579649480019" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
              </div>
            </div>
            
            <div className="footer-links">
              <h3>Quick Links</h3>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/doctors">Our Team</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/after-hours">After-Hours Care</Link></li>
                <li><Link to="/bulk-billing">Bulk Billing</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>
            
            <div className="footer-services">
              <h3>Popular Services</h3>
              <ul>
                <li><Link to="/services/skin-cancer-check">Skin Cancer Check</Link></li>
                {/* <li><Link to="/services/alternative-medicine">Alternative Medicine</Link></li> */}
                <li><Link to="/services/disease-management-program">Disease Management Program</Link></li>
                <li><Link to="/services/kids-health">Kid's Health</Link></li>
                <li><Link to="/services/mens-wellness-care">Men's Wellness Care</Link></li>
                <li><Link to="/services/primary-care-services">Primary Care Services</Link></li>
                <li><Link to="/services/womens-medical-care">Women's Medical Care</Link></li>
                <li><Link to="/services/comprehensive-health-checks">Comprehensive Health Checks</Link></li>
              </ul>
            </div>
            
            <div className="footer-contact">
              <h3>Contact Us</h3>
              <div className="contact-item">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
                <p>Shop1 and 4, 209 Myall Street, Tea Gardens, NSW 2324</p>
              </div>
              <div className="contact-item">
                <FontAwesomeIcon icon={faEnvelope} />
                <p><a href="mailto:reception01@teagardensgp.com.au">reception01@teagardensgp.com.au</a></p>
              </div>
              <div className="contact-item">
                <FontAwesomeIcon icon={faPhone} />
                <p><a href="tel:0272417750">02 7241 7750</a></p>
              </div>
              <div className="footer-logo">
                <img src="/images/logo.c881c02cbd2699dc8232-removebg-preview.png" alt="Tea Gardens GP Logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Tea Gardens GP. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
